// import PropTypes from 'prop-types';
import './Table.scss';

const Table = () => {
  const data = [
    { month: 'Sep 25', price: '75%', change: '+0.4%' },
    { month: 'Oct 25', price: '80%', change: '-1.2%' },
    { month: 'Nov 25', price: '78%', change: '+0.7%' }
  ];

  const header = [
    { key: 'month', label: 'Month', customClass: '' },
    { key: 'price', label: 'Median Price', customClass: 'table__cell--right' }
  ];

  return (
    <div className="table">
      <div className="table__row table__row--header">
        {header.map(({ label, customClass }, index) => (
          <div className={`table__cell ${customClass}`} key={`header-${index}`}>
            {label}
          </div>
        ))}
      </div>

      {data.map((row, rowIndex) => (
        <div className="table__row" key={`row-${rowIndex}`}>
          {header.map(({ key, label, customClass }, colIndex) => {
            const value = row[key];

            return (
              <div
                className={`table__cell ${customClass}`}
                key={`cell-${rowIndex}-${colIndex}`}
                data-label={label}
              >
                {key === 'price' && row.change ? (
                  <>
                    {value}
                    <span
                      className={`table__change ${
                        row.change.startsWith('+')
                          ? 'table__change--red'
                          : 'table__change--green'
                      }`}
                    >
                      ({row.change})
                    </span>
                  </>
                ) : (
                  value
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Table;
